import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

export default function NumberPad(props) {
  const {
    numberPadNumber,
    setNumberPadNumber,
    showNumberPad,
    setShowNumberPad,
    setNumberPadSelectionHandler,
    errorMessage,
    errorLimit,
    headerMessage,
  } = props;
  return (
    <Modal
      size="sm"
      show={showNumberPad}
      onHide={() => setShowNumberPad(false)}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {headerMessage}&nbsp;{numberPadNumber}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          {[...Array(9).keys()].map((k) => (
            <Button
              variant="outline-primary"
              key={k + 1}
              onClick={() => {
                const newNumberPad = numberPadNumber
                  ? Number(numberPadNumber + `${k + 1}`)
                  : k + 1;
                if (newNumberPad > errorLimit) {
                  toast.error(errorMessage);
                  return;
                }
                setNumberPadNumber(newNumberPad);
              }}
              style={{
                margin: '0.3rem',
                aspectRatio: '1/1',
                minWidth: '70px',
              }}
            >
              {k + 1}
            </Button>
          ))}
          <Button
            variant="outline-primary"
            key={0}
            onClick={() => {
              const newNumberPad = numberPadNumber
                ? Number(numberPadNumber + '0')
                : null;
              if (newNumberPad && newNumberPad > errorLimit) {
                toast.error(errorMessage);
                return;
              }
              setNumberPadNumber(newNumberPad);
            }}
            style={{
              margin: '0.3rem',
              aspectRatio: '1/1',
              minWidth: '70px',
            }}
          >
            {0}
          </Button>
          <Button
            variant="outline-danger"
            style={{
              margin: '0.3rem',
              minWidth: 'calc(140px + 0.6rem)',
              height: '70px',
            }}
            onClick={() => {
              setNumberPadNumber(null);
            }}
          >
            <i className="fas fa-close"></i>&nbsp; Temizle
          </Button>
          <Button
            style={{
              margin: '0.3rem',
              minWidth: 'calc(210px + 1.2rem)',
              height: '70px',
            }}
            variant="outline-success"
            onClick={() => {
              setNumberPadSelectionHandler(numberPadNumber);
            }}
          >
            Tamam &nbsp;
            <i className="fas fa-chevron-right"></i>
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
